import * as React from 'react';
import { cn } from '@/lib/utils';
import type { TaskPriority } from '@/types/api';

export interface PriorityBadgeProps {
  priority: TaskPriority;
  className?: string;
}

const priorityStyles = {
  high: 'bg-error/10 text-error',
  medium: 'bg-warning/10 text-warning',
  low: 'bg-primary/10 text-primary',
};

const priorityLabels = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const PriorityBadge = React.forwardRef<HTMLSpanElement, PriorityBadgeProps>(
  ({ priority, className }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium',
          priorityStyles[priority],
          className
        )}
        aria-label={`Priority: ${priorityLabels[priority]}`}
      >
        {priorityLabels[priority]}
      </span>
    );
  }
);

PriorityBadge.displayName = 'PriorityBadge';
